module.exports = __webpack_public_path__ + "static/media/next_arrow.d8c6a98b.svg";